"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

//     NoFlo - Flow-Based Programming for JavaScript
//     (c) 2013-2018 Flowhub UG
//     (c) 2011-2012 Henri Bergius, Nemein
//     NoFlo may be freely distributed under the MIT license
var BaseNetwork = require('./BaseNetwork');
/* eslint-disable
    no-param-reassign,
*/
// ## The NoFlo network coordinator
//
// NoFlo networks consist of processes connected to each other
// via sockets attached from outports to inports.
//
// The role of the network coordinator is to take a graph and
// instantiate all the necessary processes from the designated
// components, attach sockets between them, and handle the sending
// of Initial Information Packets.


var Network = /*#__PURE__*/function (_BaseNetwork) {
  _inherits(Network, _BaseNetwork);

  var _super = _createSuper(Network);

  // All NoFlo networks are instantiated with a graph. Upon instantiation
  // they will load all the needed components, instantiate them, and
  // set up the defined connections and IIPs.
  function Network(graph) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Network);

    return _super.call(this, graph, options);
  } // Add a process to the network. The node will also be registered
  // with the current graph.


  _createClass(Network, [{
    key: "addNode",
    value: function addNode(node, options, callback) {
      var _this = this;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      _get(_getPrototypeOf(Network.prototype), "addNode", this).call(this, node, options, function (err, process) {
        if (err) {
          callback(err);
          return;
        }

        if (!options.initial) {
          _this.graph.addNode(node.id, node.component, node.metadata);
        }

        callback(null, process);
      });
    } // Remove a process from the network. The node will also be removed
    // from the current graph.

  }, {
    key: "removeNode",
    value: function removeNode(node, callback) {
      var _this2 = this;

      _get(_getPrototypeOf(Network.prototype), "removeNode", this).call(this, node, function (err) {
        if (err) {
          callback(err);
          return;
        }

        _this2.graph.removeNode(node.id);

        callback();
      });
    } // Rename a process in the network. Renaming a process also modifies
    // the current graph.

  }, {
    key: "renameNode",
    value: function renameNode(oldId, newId, callback) {
      var _this3 = this;

      _get(_getPrototypeOf(Network.prototype), "renameNode", this).call(this, oldId, newId, function (err) {
        if (err) {
          callback(err);
          return;
        }

        _this3.graph.renameNode(oldId, newId);

        callback();
      });
    } // Add a connection to the network. The edge will also be registered
    // with the current graph.

  }, {
    key: "addEdge",
    value: function addEdge(edge, options, callback) {
      var _this4 = this;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      _get(_getPrototypeOf(Network.prototype), "addEdge", this).call(this, edge, options, function (err) {
        if (err) {
          callback(err);
          return;
        }

        if (!options.initial) {
          _this4.graph.addEdgeIndex(edge.from.node, edge.from.port, edge.from.index, edge.to.node, edge.to.port, edge.to.index, edge.metadata);
        }

        callback();
      });
    } // Remove a connection from the network. The edge will also be removed
    // from the current graph.

  }, {
    key: "removeEdge",
    value: function removeEdge(edge, callback) {
      var _this5 = this;

      _get(_getPrototypeOf(Network.prototype), "removeEdge", this).call(this, edge, function (err) {
        if (err) {
          callback(err);
          return;
        }

        _this5.graph.removeEdge(edge.from.node, edge.from.port, edge.to.node, edge.to.port);

        callback();
      });
    } // Add an IIP to the network. The IIP will also be registered with the
    // current graph. If the network is running, the IIP will be sent immediately.

  }, {
    key: "addInitial",
    value: function addInitial(iip, options, callback) {
      var _this6 = this;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      _get(_getPrototypeOf(Network.prototype), "addInitial", this).call(this, iip, options, function (err) {
        if (err) {
          callback(err);
          return;
        }

        if (!options.initial) {
          _this6.graph.addInitialIndex(iip.from.data, iip.to.node, iip.to.port, iip.to.index, iip.metadata);
        }

        callback();
      });
    } // Remove an IIP from the network. The IIP will also be removed from the
    // current graph.

  }, {
    key: "removeInitial",
    value: function removeInitial(iip, callback) {
      var _this7 = this;

      _get(_getPrototypeOf(Network.prototype), "removeInitial", this).call(this, iip, function (err) {
        if (err) {
          callback(err);
          return;
        }

        _this7.graph.removeInitial(iip.to.node, iip.to.port);

        callback();
      });
    }
  }]);

  return Network;
}(BaseNetwork);

exports.Network = Network;